import { useEffect, useState } from "react";
import { JService } from "../api-service/ApiService";
import Button from "../design/Button";
import { enqueueSnackbar } from 'notistack';
import { useSelector } from "react-redux";
import AnimationPage from "../shared/animation-page/AnimationPage";
import { CustomSelect } from "../design/components/customComponents";

function GeneralTab(props) {
  const user = useSelector((state) => state?.account?.value);
  const reduxCredits = user?.credits;
  const reduxSubscription = user?.subscription;
  const currency = reduxCredits?.currency === "USD" ? "$" : "₹";
  const { originalSettings, setOriginalSettings, surveysList, showLoader } = props;
  const accessList = useSelector(state => state?.account?.value?.data?.access_list);

  //States
  const [numberName, setNumberName] = useState("");
  const [numberType, setNumberType] = useState("");
  const [recordCalls, setRecordCalls] = useState(false);
  const [amdEnabled, setAmdEnabled] = useState(false);
  const [postCallSurveyEnabled, setPostCallSurveyEnabled] = useState(false);
  const [postCallSurvey, setPostCallSurvey] = useState(null);
  const [stickyAgent, setStickyAgent] = useState(false);
  const { number, location, country_code } = originalSettings;

  useEffect(() => {
    const { name, type, record_calls, post_call_survey, ivr_surveys } =
      originalSettings;
    setNumberName(name);
    setNumberType(type);
    setRecordCalls(record_calls);
    setStickyAgent(originalSettings?.sticky_agent);
    setPostCallSurveyEnabled(post_call_survey);
    setPostCallSurvey(ivr_surveys?.length > 0 ? (ivr_surveys[0]??{}).id : null);
    setAmdEnabled(originalSettings?.amd_enabled);
  }, [originalSettings]);

  const isSaveDisabled = () => {
    return !(
      (numberName !== originalSettings.name && numberName !== "") ||
      recordCalls !== originalSettings.record_calls || 
      amdEnabled !== originalSettings.amd_enabled ||
      (stickyAgent !== originalSettings.sticky_agent &&
        numberType === "Voice Broadcast")
    );
  };

  const isSaveSurveySettingsDisabled = () => {
    return (
      (postCallSurveyEnabled === originalSettings.post_call_survey &&
        postCallSurvey == originalSettings?.["ivr_surveys"]?.[0]?.id) ||
      (postCallSurveyEnabled && !postCallSurvey)
    );
  };

  const handleSave = () => {
    let url;
    const payload = {};

    if (numberName !== originalSettings.name && numberName !== "")
      payload.name = numberName;
    if (recordCalls !== originalSettings.record_calls)
      payload.record_calls = recordCalls;
    if (amdEnabled !== originalSettings.amd_enabled)
      payload.amd_enabled = amdEnabled;

    const originalSurveyId = originalSettings?.ivr_surveys?.[0]?.id ?? null;
    const newSurveyId = postCallSurveyEnabled ? postCallSurvey : null;
    if (postCallSurveyEnabled !== originalSettings.post_call_survey)
      payload.post_call_survey = postCallSurveyEnabled;
    if (newSurveyId != originalSurveyId)
      payload.survey_id = newSurveyId;

    if (originalSettings.type === "Calling") {
      url = `/api/v1/auth/virtual-numbers/calling/${originalSettings.id}/`;
    } else if (originalSettings.type === "Voice Broadcast") {
      url = `/api/v1/auth/virtual-numbers/voice-broadcast/${originalSettings.id}/`;
      if (stickyAgent !== originalSettings.sticky_agent)
        payload["sticky_agent"] = stickyAgent;
    } else return;

    JService.patch(url, payload)
      .then((res) => {
        if (!res?.success)
          throw new Error(
            res?.message || "Error while updating virtual number",
          );

        setOriginalSettings({ ...originalSettings, ...res.data });
        enqueueSnackbar(res?.message, { variant: "success" });
      })
      .catch((err) => enqueueSnackbar(err?.message, { variant: "error" }));
  };

  return (
    <>
      {showLoader && <AnimationPage/>}
      {!showLoader && 
      <>
      <div>
        <p className="t5 medium-font" style={{ marginTop: "40px", marginBottom: "40px" }}>Number</p>

        <form
          className="new-contact-list-form add-contact-form virtual-numbers-form"
          style={{ maxWidth: "400px", marginBottom: "82px" }}
        >
          <label className="t7 medium-font">
            Number name
            <input
              placeholder="Enter name"
              className="px-14"
              type="text"
              onChange={(e) => {
                setNumberName(e.target.value);
              }}
              value={numberName}
              style={{ marginTop: "4px" }}
            />
          </label>
          <label className="t7 medium-font" style={{ marginTop: "20px" }}>
            Virtual number
            <input
              className="px-14"
              type="text"
              value={location ? (country_code + "" + number + " (" + location + ")") : country_code + "" + number}
              disabled
              style={{ marginTop: "4px" }}
            />
          </label>
          <label className="switch" style={{ marginTop: "40px" }}>
            <input
              type="checkbox"
              checked={recordCalls}
              onChange={(e) => {
                setRecordCalls(e.target.checked);
              }}
              style={{ cursor: "pointer", marginTop: "0" }}
            />
            <span className="slider round"></span>
            <p
              style={{
                marginTop: "-6px",
                marginLeft: "60px",
                width: "400px",
              }}
              className="t6 regular-font nc-gray-900"
            >
              Record calls
            </p>
            <p
              className="t6 regular-font nc-gray-600"
              style={{ width: "340px", marginLeft: "60px", marginTop: "0" }}
            >
              {`Automatically record all incoming ${
                numberType === "Calling" ? "and outgoing calls" : "calls"
              } to this virtual number.`}
            </p>
          </label>
          {accessList?.includes("AMD") && 
            <label className="switch" style={{ marginTop: "60px" }}>
              <input
                type="checkbox"
                checked={amdEnabled}
                onChange={(e) => {
                  setAmdEnabled(e.target.checked);
                }}
                style={{ cursor: "pointer", marginTop: "0" }}
              />
              <span className="slider round"></span>
              <p
                style={{
                  marginTop: "-6px",
                  marginLeft: "60px",
                  width: "400px",
                }}
                className="t6 regular-font nc-gray-900"
              >
                Answering machine detection
              </p>
              <p
                className="t6 regular-font nc-gray-600"
                style={{ width: "340px", marginLeft: "60px", marginTop: "0" }}
              >
                Detect when a call is answered by a voicemail. Charged at {currency}{originalSettings?.amd_cost} per call.
              </p>
            </label>
          }
        </form>

        <Button
          variant="filled"
          buttonText="Save"
          icon={{}}
          disabled={isSaveDisabled()}
          isLoading={false}
          hierarchy="green"
          onClick={handleSave}
          buttonStyle={{marginBottom: "20px"}}
        />
      </div>
      {country_code === "+91" && accessList?.includes("IVR SURVEY") && (
        <>
          <hr style={{ margin: "40px 0" }} />
          <div style={{ marginBottom: "60px" }}>
            <h2 className="t5 medium-font nc-gray-900">Post call survey</h2>
            <form style={{ maxWidth: "400px" }}>
              <label
                className="switch"
                style={{ marginTop: "32px", marginBottom: "24px" }}
              >
                <input
                  type="checkbox"
                  checked={postCallSurveyEnabled}
                  onChange={(e) => {
                    setPostCallSurveyEnabled(e.target.checked);
                  }}
                  style={{ cursor: "pointer", marginTop: "0" }}
                />
                <span className="slider round"></span>
                <p
                  style={{
                    marginTop: "-25px",
                    marginLeft: "60px",
                    width: "400px",
                  }}
                  className="t6 regular-font nc-gray-900"
                >
                  Post call survey
                </p>
                <p
                  className="t6 regular-font nc-gray-600"
                  style={{ width: "340px", marginLeft: "60px", marginTop: "0" }}
                >
                  Allow users to initiate survey at the end of call.
                </p>
              </label>
              <div className="select-container">
                <CustomSelect
                  label="Select survey"
                  value={postCallSurvey}
                  handleChange={(e) => {
                    setPostCallSurvey(e.target.value);
                  }}
                  options={surveysList?.map(elem => ({value: elem.id, displayValue: elem.title}))}
                  defaultValue={surveysList?.[0]?.title}
                  disabled={!postCallSurveyEnabled}
                  labelStyles={{marginTop: '24px'}}
                />
              </div>
              <Button
                variant="filled"
                buttonText="Save"
                icon={{}}
                disabled={isSaveSurveySettingsDisabled()}
                isLoading={false}
                hierarchy="green"
                onClick={handleSave}
              />
          </form>
        </div>
        </>)}
      </>
      }    
      </>
  );
}

export default GeneralTab;
